import React, { useState, useEffect } from 'react';

export default function useWordCount(editorEl){
  const [wordCount, setWordCount] = useState(0)

  const handleWordCount = () => {
    let editorText = editorEl.current.innerText;
    let regex = /\s+/gi;
    let editorTextArray = editorText
      .trim()
      .replace(regex, ' ')
      .split(' ');
    let wordCount = editorTextArray.length;
    editorTextArray[0] ? setWordCount(wordCount) : setWordCount(0);
  };

  useEffect(() => {
    handleWordCount()
  })

  return wordCount
}




// WEBPACK FOOTER //
// ./app/javascript/client/editor-ui/hooks/useWordCount.js